module.exports = __webpack_public_path__ + "static/media/19.99bb4415.webp";